import { collection, collectionGroup, doc, addDoc, getDoc, setDoc, updateDoc, deleteDoc, getDocs, onSnapshot, query, where, orderBy, limit, runTransaction } from "firebase/firestore";

const dbFns = {
  collection,
  collectionGroup,
  doc,
  addDoc,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  orderBy,
  limit,
  runTransaction
};

export default dbFns;